import React, { useState, useEffect } from 'react';
import { CheckCircle2, MapPin } from 'lucide-react';
const names = ["Juan", "Martín", "Carlos", "Lucas", "Diego", "Fernando", "Pablo", "Alejandro", "Matías", "Nicolás", "Facundo", "Gonzalo", "Federico", "Agustín", "Ezequiel", "Tomás", "Gabriel", "Rodrigo", "Hernán", "Jorge", "Mariano", "Cristian", "Maximiliano"];
const cities = ["Buenos Aires", "Córdoba", "Rosario", "Mendoza", "Tucumán", "La Plata", "Mar del Plata", "Salta", "Santa Fe", "San Juan", "Resistencia", "Neuquén", "Posadas", "San Salvador de Jujuy", "Bahía Blanca", "Paraná", "Santiago del Estero", "Corrientes", "San Luis", "Bariloche", "Comodoro Rivadavia", "Santa Rosa"];
export function SalesPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchase, setPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);

      // Ocultar el popup después de 5 segundos
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };

    // Mostrar el primero a los 10 segundos para que el usuario lo vea pronto
    const initialTimeout = setTimeout(() => {
      triggerPopup();
      // Luego configurar el intervalo para que aparezca cada 1 minuto (60000 ms)
      intervalId = setInterval(triggerPopup, 60000);
    }, 10000);
    return () => {
      clearTimeout(initialTimeout);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);
  return <div className={`fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-239" data-mp="2xev0lemi7k7j">
      <div className="bg-white rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-gray-100 p-4 flex items-start gap-4 w-[300px] md:w-[340px]" data-id="element-240" data-mp="1336r3rz1k9uj">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-0.5" data-id="element-241" data-mp="q2uw1fmdadt0">
          <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-242" data-mp="14z3tcbmp6h2s" />
        </div>
        <div data-id="element-243" data-mp="zzqx509xrxnj">
          <p className="text-[13px] md:text-[14px] text-[#07152D] font-[800] leading-tight mb-1.5" data-id="element-244" data-mp="zz7qifpqkvot">
            {purchase.name} compró Mecánico Industrial PRO
          </p>
          <div className="flex items-center gap-1 text-[11px] md:text-[12px] text-gray-500 font-[600]" data-id="element-245" data-mp="1dx5quh782rlb">
            <MapPin className="w-3 h-3 text-gray-400" data-id="element-246" data-mp="1npbrefbjihc4" />
            <span data-id="element-247" data-mp="1nos9gylw3sy3">{purchase.city}, Argentina</span>
          </div>
          <p className="text-[10px] text-[#142FA8] mt-2 font-[700] uppercase tracking-wider" data-id="element-248" data-mp="1ipp5lhhnbsrp">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}